import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Category from './Category';

const LeftsideBar = () => {
  const [categories, setCategory] = useState([]);

  useEffect(() =>{
    fetch('http://localhost:5000/news-categories')
    .then(res => res.json())
    .then(data => setCategory(data))
  },[])


  return (
    <div className=''>
      <div className='sticky top-5'>
        <h2 className='text-2xl font-medium text-gray-600'>All Category</h2>
        <ul className='mt-8 tracking-wide'>
          {
            categories.map(category => <Category 
              key = {category.id}
              category = {category}
              ></Category>)
          }
        </ul>
      </div>
    </div>
  );
};

export default LeftsideBar;